import { WhatsApp } from "@mui/icons-material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import {
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import Cookies from "js-cookie";
import { supportNumber } from "../../../../../utils/supportNumber";

const Mobile = ({ newCertificate, nome, server, setURL, setOpenDialog }) => {
  return newCertificate.map((cert) => {
    const { descrprod, serie, unique } = cert;

    return (
      <Card
        key={serie}
        elevation={2}
        sx={{
          borderRadius: 3,
          width: "100%",
          cursor: "pointer",
          mb: 2,
        }}
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Box flex={1} display="flex" flexDirection="column">
              <Typography variant="subtitle1">
                <strong>Produto: </strong>
                {descrprod}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Série: </strong>
                {serie}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 1 }} />
          <Button
            variant="outlined"
            sx={{ mb: 1 }}
            disabled={unique[9] === "1010200"}
            fullWidth
            endIcon={<WorkspacePremiumIcon />}
            onClick={() => {
              const options = {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  Authorization: "Bearer " + Cookies.get("bearer"),
                },
                body: new URLSearchParams({
                  nomeparc: nome,
                  jsonid: localStorage.getItem("token"),
                  serie: unique[10],
                  nomeprod: unique[7],
                  codprod: unique[6],
                  cnpj: nome?.trim?.(),
                  bu: localStorage.getItem("segmento"),
                  series: JSON.stringify([unique[10]]),
                }),
              };

              fetch(`${server}portalCliente/gera_certificado`, options)
                .then((response) => response.text())
                .then((response) => {
                  setURL(response);
                  setOpenDialog(true);
                })
                .catch((err) => console.error(err));
            }}
          >
            Acessar Certificado
          </Button>
          <Button
            variant="outlined"
            color="success"
            fullWidth
            disabled={unique[9] === "1010200"}
            endIcon={<WhatsApp />}
            href={`https://wa.me/${supportNumber.whatsApp}?text=Ol%C3%A1%21+Gostaria+de+falar+sobre+os+consum%C3%ADveis`}
          >
            WhatsApp
          </Button>
        </CardContent>
      </Card>
    );
  });
};

export default Mobile;
